import type { UserMaterial } from '@/lib/api/materials';
import type { SubjectModel } from '@/types/subject-model';

/** Kagemane consumes an owned reference image, not a supplier training identity. */
export function kagemaneSubjectReference(model: SubjectModel): UserMaterial | null {
  if (model.status !== 'active' || model.analysis_status !== 'completed') return null;
  const cover = model.anchor_images?.[0];
  if (!cover?.asset_id || !cover.url) return null;
  return {
    id: cover.asset_id,
    name: model.name,
    display_name: model.name,
    file_type: 'image',
    storage_path: '',
    url: cover.url,
    thumbnail_url: cover.url,
    width: cover.width,
    height: cover.height,
    asset_category: 'project_asset',
    material_type: 'general',
    created_at: model.created_at,
    updated_at: model.updated_at,
  };
}
